(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.PlantingRxService = (function(superClass) {
    extend(PlantingRxService, superClass);

    function PlantingRxService(http, rootScope, promise1) {
      this.http = http;
      this.rootScope = rootScope;
      this.promise = promise1;
      this.calculateTargetPop = bind(this.calculateTargetPop, this);
      this._cleanedTruthStripsForSolver = bind(this._cleanedTruthStripsForSolver, this);
      this._cleanedHybridsForSolver = bind(this._cleanedHybridsForSolver, this);
      this.getHybrids = bind(this.getHybrids, this);
      this.asSaveOptions = bind(this.asSaveOptions, this);
      this._getValuesForComparison = bind(this._getValuesForComparison, this);
      this.compareSolverOptions = bind(this.compareSolverOptions, this);
      this.mergeOptions = bind(this.mergeOptions, this);
      this.asSolverOptions = bind(this.asSolverOptions, this);
      this.reset = bind(this.reset, this);
      this.getStripPolygons = bind(this.getStripPolygons, this);
      this.setPopulation = bind(this.setPopulation, this);
      this.averagePop = bind(this.averagePop, this);
      this.reset();
    }

    PlantingRxService.prototype.averagePop = function(use_temp) {
      var acres, avg, i, len, pop, pop_value, ref, total_acres;
      if (use_temp == null) {
        use_temp = false;
      }
      avg = 0;
      total_acres = 0;
      ref = this.data.populations;
      for (i = 0, len = ref.length; i < len; i++) {
        pop = ref[i];
        if (pop.truth_strip) {
          continue;
        }
        acres = parseFloat(pop.acres);
        total_acres += acres;
        if (use_temp) {
          pop_value = pop.temp_population;
        } else {
          pop_value = pop.population;
        }
        avg += acres * pop_value;
      }
      if (total_acres > 0) {
        avg = avg / total_acres;
        return Math.round(avg);
      } else {
        return '';
      }
    };

    PlantingRxService.prototype.setPopulation = function(row, val, reeval_avg) {
      var i, len, strip, strips;
      if (reeval_avg == null) {
        reeval_avg = true;
      }
      if (row.truth_strip) {
        strips = this.getStripPolygons(row);
        for (i = 0, len = strips.length; i < len; i++) {
          strip = strips[i];
          strip.population = val;
          strip.orig_population = val;
          strip.temp_population = val;
        }
      } else {
        row.population = val;
        row.orig_population = val;
        row.temp_population = val;
      }
      if (this.data.truth_strips.length > 0 && reeval_avg) {
        row = this.data.truth_strips[0];
        return this.setPopulation({
          truth_strip: true,
          strip_id: row.strip_id,
          real_strip_id: row.real_strip_id
        }, this.averagePop(true), false);
      }
    };

    PlantingRxService.prototype.getStripPolygons = function(strip) {
      var list, real, ref;
      list = _.filter(this.data.populations, {
        truth_strip: 'Yes',
        truth_strip_id: (ref = strip.strip_id) != null ? ref : strip.truth_strip_id
      });
      if (strip.real_strip_id != null) {
        real = _.filter(this.data.populations, {
          truth_strip: 'Yes',
          real_strip_id: strip.real_strip_id
        });
        list = list.concat(real);
      }
      return _.uniq(list);
    };

    PlantingRxService.prototype.loadFromStorage = function(RxStorage) {
      var promise;
      this.data.crops_id = RxStorage.retrieve('crop');
      this.data.crops_name = RxStorage.retrieve('crop_name');
      this.data.fields_name = RxStorage.retrieve('field_name');
      this.data.spp_id = RxStorage.retrieve('spp_id');
      this.data.fsr_id = RxStorage.retrieve('fsr_id');
      this.data.solver_variables = RxStorage.retrieve('solver_variables', {});
      this.data.yield_goal = RxStorage.retrieve('yield_goal');
      promise = this.http.post('backend/grower/layers/planting-rx/ng-get-layer', RxStorage.except('spp')).then((function(_this) {
        return function(result) {
          _this.mergeOptions(result.data.data);
          return _this;
        };
      })(this));
      return promise;
    };

    PlantingRxService.prototype.save = function() {
      return this.http.post('backend/grower/layers/planting-rx/save', {
        layer: this.asSaveOptions()
      });
    };

    PlantingRxService.prototype.reset = function() {
      return this.data = {
        id: null,
        year: null,
        spp_id: null,
        crops_id: null,
        layers_id: null,
        fields_id: null,
        crops_name: null,
        fields_name: null,
        previous_visual_layers: null,
        cross_crop_operations_id: null,
        want_truth_strips: false,
        visual_layers: [],
        solver_variables: {},
        planting_selections: [],
        truth_strips: [],
        populations: [],
        populations_geom: [],
        yield_goal: null,
        planter: null,
        refuge: null,
        refuge_in_blocks: null,
        productivity_index: null,
        previous_calculation: null
      };
    };

    PlantingRxService.prototype.asSolverOptions = function() {
      var layer, truth_strips;
      if (this.data.want_truth_strips) {
        truth_strips = this._cleanedTruthStripsForSolver();
      } else {
        truth_strips = [];
      }
      layer = $.extend(true, {}, {
        recalculate: true,
        layer: {
          id: this.data.id,
          visual_layers: this.data.visual_layers,
          fields_id: this.data.fields_id,
          spp_id: this.data.spp_id,
          cross_crop_operations_id: this.data.cross_crop_operations_id,
          crops_id: this.data.crops_id,
          solver_variables: this.data.solver_variables,
          hybrids: this._cleanedHybridsForSolver(),
          truth_strips: truth_strips,
          productivity_index: this.data.productivity_index,
          fsr_id: this.data.fsr_id
        }
      });
      if (this.data.yield_goal) {
        layer.layer.yield_goal = this.data.yield_goal;
      }
      return layer;
    };

    PlantingRxService.prototype.mergeOptions = function(options) {
      return $.extend(true, this.data, options);
    };

    PlantingRxService.prototype.compareSolverOptions = function(new_options) {
      var new_layer, old_layer, old_options;
      old_options = this.asSolverOptions();
      new_layer = this._getValuesForComparison(new_options);
      old_layer = this._getValuesForComparison(old_options);
      return _.isEqual(new_layer, old_layer);
    };

    PlantingRxService.prototype._getValuesForComparison = function(options) {
      var layer;
      layer = _.assign({}, options.layer, {
        cross_crop_operations_id: null
      });
      layer.visual_layers = layer.visual_layers.map(function(layer) {
        return {
          id: layer.id,
          type: layer.type
        };
      });
      return layer;
    };

    PlantingRxService.prototype.asSaveOptions = function() {
      var i, j, k, layer, len, len1, len2, pop, popd, ref, ref1, ref2, request_data, strip;
      request_data = {
        id: this.data.id,
        layers_id: this.data.layers_id,
        fields_id: this.data.fields_id,
        machinery_planters_id: this.data.planter.id,
        planter_rows: this.data.planter.number_of_rows,
        crop_id: this.data.crops_id,
        year: this.data.year,
        spp_id: this.data.spp_id,
        base_layers: [],
        cross_crop_operations_id: this.data.cross_crop_operations_id,
        hybrids: [],
        populations: [],
        truth_strips: [],
        target_pop: this.data.solver_variables.target,
        min_pop_diff: this.data.solver_variables.min_pop_diff,
        max_pop_diff: this.data.solver_variables.max_pop_diff,
        max_num_pops: this.data.solver_variables.max_num_pops,
        min_pop: this.data.solver_variables.min_pop,
        max_pop: this.data.solver_variables.max_pop
      };
      ref = this.data.visual_layers;
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        request_data.base_layers.push({
          id: layer.id,
          type: layer.type
        });
      }
      request_data.hybrids = this.getHybrids();
      ref1 = this.data.populations_geom.getLayers();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        pop = ref1[j];
        popd = $.extend({}, pop.feature.properties);
        popd.geom = pop.toGeoJSON().geometry;
        request_data.populations.push(popd);
      }
      ref2 = this.data.truth_strips;
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        strip = ref2[k];
        request_data.truth_strips.push({
          geom: strip.poly.toGeoJSON().geometry,
          strip_id: strip.strip_id,
          real_strip_id: strip.real_strip_id
        });
      }
      return request_data;
    };

    PlantingRxService.prototype.getHybrids = function() {
      var hybrid, hybrids, i, len, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      hybrids = [];
      ref = this.data.planting_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        hybrid = ref[i];
        if (hybrid.active) {
          hybrids.push({
            id: hybrid.brand.id,
            hybrids_name: hybrid.brand.name,
            hybrids_id: hybrid.brand.id,
            products_id: hybrid.brand.products_id,
            is_high_yield: (ref1 = hybrid.primary) != null ? ref1 : false,
            is_low_yield: (ref2 = !hybrid.primary) != null ? ref2 : true,
            is_refuge: false,
            treatments_id: (ref3 = hybrid.treatment) != null ? ref3.id : void 0,
            treatments_name: (ref4 = hybrid.treatment) != null ? ref4.name : void 0,
            active: true,
            units: hybrid.units,
            acres: hybrid.acres
          });
        }
      }
      if ((ref5 = this.data.refuge) != null ? ref5.active : void 0) {
        hybrids.push({
          id: this.data.refuge.brand.id,
          hybrids_name: this.data.refuge.brand.name,
          hybrids_id: this.data.refuge.brand.id,
          products_id: this.data.refuge.brand.products_id,
          is_high_yield: false,
          is_low_yield: false,
          is_refuge: true,
          treatments_id: (ref6 = this.data.refuge.treatment) != null ? ref6.id : void 0,
          treatments_name: (ref7 = this.data.refuge.treatment) != null ? ref7.name : void 0,
          active: true,
          units: this.data.refuge.units,
          acres: this.data.refuge.acres
        });
      }
      return hybrids;
    };

    PlantingRxService.prototype.selectedHybridIds = function() {
      var h, i, ids, len, ref;
      ids = [];
      ref = this.data.planting_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        h = ref[i];
        if (h.active) {
          if (h.brand != null) {
            ids.push(h.brand.id);
          }
        }
      }
      return ids;
    };

    PlantingRxService.prototype._cleanedHybridsForSolver = function() {
      var cleaned, h, i, len, ref, ref1;
      cleaned = [];
      ref = this.data.planting_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        h = ref[i];
        if (h.active) {
          cleaned.push({
            hybrids_id: (ref1 = h.brand) != null ? ref1.id : void 0,
            is_refuge: h.refuge,
            active: true
          });
        }
      }
      return cleaned;
    };

    PlantingRxService.prototype._cleanedTruthStripsForSolver = function() {
      var cleaned, i, len, ref, strip;
      cleaned = [];
      ref = this.data.truth_strips;
      for (i = 0, len = ref.length; i < len; i++) {
        strip = ref[i];
        if (strip.poly_raw != null) {
          cleaned.push(turf.polygon(JSON.parse(strip.poly_raw).coordinates));
        } else {
          cleaned.push(strip.poly.toGeoJSON());
        }
      }
      return cleaned;
    };

    PlantingRxService.prototype.calculateTargetPop = function() {
      var elem, i, len, params, products, ref;
      products = [this.data.planting_selections[0].brand.id];
      ref = this.data.planting_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        elem = ref[i];
        if (!elem.primary && !elem.refuge && elem.active) {
          products.push(elem.brand.id);
        }
      }
      params = {
        field_id: this.data.fields_id,
        fsr_id: this.data.fsr_id,
        spp_id: this.data.spp_id,
        year: this.data.year,
        products: products,
        planter_id: this.data.planter.id,
        min_max_pop: {
          min: this.data.solver_variables.min_pop,
          max: this.data.solver_variables.max_pop
        },
        is_rx: true,
        rx_base_layers: this.data.visual_layers,
        max_num_pops: this.data.solver_variables.max_num_pops
      };
      return this.http.post('backend/grower/layers/planting-rx/calculate-target-population', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(population) {
          if ($.isNumeric(population)) {
            _this.data.solver_variables.target = parseInt(population);
          }
          return population;
        };
      })(this));
    };

    return PlantingRxService;

  })(Service);

}).call(this);
